import React from 'react';
import {
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableCell,
  TableHead,
} from 'src/components/ui/table';
import { SupplierProductDTO } from 'src/api/accounts-payable/useSupplier';

interface SupplierProductsTabProps {
  products?: SupplierProductDTO[];
}

export function SupplierProductsTab({ products }: SupplierProductsTabProps) {
  return (
    <div className="p-6">
      <h2 className="text-xl font-medium mb-6">Supplier Products</h2>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>
              <span className="text-xs font-medium text-gray-600">Name</span>
            </TableHead>
            <TableHead>
              <span className="text-xs font-medium text-gray-600">
                Unit of Measure
              </span>
            </TableHead>
            <TableHead>
              <span className="text-xs font-medium text-gray-600">
                Unit Price
              </span>
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {products?.map((product) => (
            <TableRow key={product.id}>
              <TableCell>
                <span className="text-sm">{product.product.name}</span>
              </TableCell>
              <TableCell>
                <span className="text-sm">
                  {product.unitVariation.unitOfMeasure || '-'}
                </span>
              </TableCell>
              <TableCell>
                <span className="text-sm">
                  {product.unitPrice
                    ? `$${Number(product.unitPrice).toFixed(2)}`
                    : '-'}
                </span>
              </TableCell>
            </TableRow>
          ))}
          {(!products || products.length === 0) && (
            <TableRow>
              <TableCell colSpan={3}>
                <div className="text-center py-4">
                  <span className="text-sm text-gray-600">
                    No products found for this supplier
                  </span>
                </div>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
}
